
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import OrderList from './List';
import OrderAdd from './Add';
import OrderEdit from './Edit';


export default class OrderRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path={['/order/list_table/preview/:id', '/order/list_table', '/order/preview/:id', '/order']} exact component={OrderList} />
        <Route path="/order/add" exact component={OrderAdd} />
        <Route path="/order/add/:id" exact component={OrderAdd} />
        <Route path="/order/:id" component={OrderEdit} />
      </Switch>
    );
  }
}
